import React, { Component } from 'react'
import Modal from 'react-modal'
import { CloseIcon } from './closeIcon'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  currentModal?: string
  height?: string
  hideModal?: Callback
  title: string
  titleClass?: string
  width?: string
  xclose?: boolean
}

export class ModalWrapper extends Component<Props> {
  static displayName = 'ModalWrapper'

  render() {
    const {
      currentModal,
      hideModal,
      title,
      titleClass = 'h1 modal__header',
      height = '600px',
      width = '1050px',
      xclose = false,
    } = this.props

    const modalStyles = {
      overlay: {
        zIndex: 999,
      },
      content: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        background: '#fff',
        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.5)',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '0',
        outline: 'none',
        padding: '0 4rem 4rem',
        width,
        height,
        transform: 'translate(-50%, -50%)',
      },
    }

    const titleStyle = {
      color: '#fff',
    }

    return (
      <Modal
        appElement={document.getElementById('root')}
        isOpen={currentModal !== null}
        onRequestClose={hideModal}
        contentLabel="Modal"
        style={modalStyles}
        className="modal"
      >
        {xclose ? (
          <button
            onClick={hideModal}
            aria-label="Close Modal"
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              lineHeight: 0,
              color: '#fff',
            }}
          >
            <CloseIcon />
          </button>
        ) : (
          <button className="button button--primary" onClick={hideModal}>
            Close
          </button>
        )}
        <h4 className={titleClass} style={titleStyle}>
          {title}
        </h4>
        {this.props.children}
      </Modal>
    )
  }
}
